// Canonical entitlement type values shared by LeMans Home UI and Common Admin.
export enum EntitylementTypes {
  addOns = 'addon',
  trial = 'trial',
  platform = 'platform',
  additive = 'additive',
  utilityToken = 'utilityToken',
}

export enum EntitlementBadge {
  addon = 'Add-On',
  platform = 'Platform',
  additive = 'Additive',
  trial = 'Trial',
  utilityToken = 'Universal Credits',
}
